import classNames from 'classnames';
import SectionTitle from 'UI/components/SectionTitle';
import { getDocumentFields } from 'utils/helper';
import { get } from 'lodash';
import Svg from 'UI/components/Svg';
import LinkWrapper from 'components/Common/LinkWrapper';
import Image from 'next/image';
import { getContentfulImage } from 'UI/components/Illustration/utils/helpers';
import Illustration from 'UI/components/Illustration';
import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import styles from './styles.module.scss';
import { getFeaturedProjectProps } from './utils/helpers';

const SvgList = ({
  section,
  data,
  type,
}) => {
  const {
    title,
    description,
    view,
    contentModules,
  } = getDocumentFields(
    data || section,
    [
      'title',
      'description',
      'contentModules',
      'view',
    ],
  );
  const { contentList: svgList } = getDocumentFields(get(contentModules, '[0]', {}), ['contentList']);

  const { contentModules: featuredProjects = [] } = getDocumentFields(get(contentModules, '[1]', {}), ['contentModules']);

  return (
    <section className={classNames(styles.section, styles[type], styles[view])}>
      <SectionTitle
        title={title}
        description={description}
        titleStyle={styles.titleStyle}
      />
      <div className={styles.container}>
        {(svgList || []).map((item) => (
          <Svg
            key={item}
            type={item}
            className={styles.svg}
          />
        ))}
      </div>
      {/* Add animation? */}
      {!!featuredProjects?.length && (
        <div className={styles.teamList}>
          {featuredProjects.map((project) => {
            const {
              projectTitle,
              imageUrl,
              projectLink,
              text,
            } = getFeaturedProjectProps(project);

            return (
              <LinkWrapper
                isLocalLink
                path={projectLink}
                className={styles.projectLink}
              >
                <div className={styles.memberContainer}>
                  <div className={styles.imageContainer}>
                    <Illustration
                      transparent
                      className={styles.memberImage}
                      src={imageUrl}
                      key={`intro-images-bundles/${imageUrl}`}
                    />
                    {/* <Image
                      src={getContentfulImage({ src: imageUrl, format: 'webp', width: 600 })}
                      width={272}
                      height={140}
                      lazyBoundary="700px"
                      unoptimized
                      loader={(args) => getContentfulImage({ ...args, format: 'webp', width: 300 })}
                      className={styles.memberImage}
                    /> */}
                  </div>
                  <p>{projectTitle}</p>
                  {text && <ContentfulParser document={text} />}
                </div>
              </LinkWrapper>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default SvgList;
